export const locale = {
    lang: "pt-BR",
    data: {
        DIALOG: {
            TITLE: "Erros ao importar usuários",
            VALIDS: "linhas a serem importadas",

            GRID: {
                LINE: "Linha",
                EMAIL: "Email",
                ERRORS: "Erros"
            },
            COPY: "Copiar erro",
            COPY_ALL: "Copiar tudo",
            COPIED: "Erros copiados com sucesso."
        }
    }
};
